import {Component} from "preact";
import {ButtonHTMLAttributes} from "preact/compat";
import {classNames} from "../classNames";
import style from "./Button.module.css";
import {Spinner} from "./Spinner";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	primary?: boolean;
	choice?: boolean;
	danger?: boolean;
	success?: boolean;
	pending?: boolean;
}

export class Button extends Component<ButtonProps> {
	render() {
		const {primary = false, choice = false, danger = false, success = false, pending = false, children, ...props} =
			this.props;
		return (
			<button
				class={classNames(
					style.button,
					primary && style.primary,
					choice && style.choice,
					danger && style.danger,
					success && style.success,
				)}
				{...props}
			>
				{pending && (
					<div class={style.pendingIcon}>
						<Spinner class={style.pendingIcon} />
					</div>
				)}
				{children}
			</button>
		);
	}
}
